import React from "react";
import { Link, NavLink } from "react-router-dom";
import ScheduleCardPopup from "./ScheduleCardPopup";
import { Popup } from "semantic-ui-react";
// css comes in published_hw.css

const ScheduleAssessBoxHW = (props) => {
  return (
    <div className="hw_published_card2" style={{ height: "97px" }}>
      <div className="hw_card_class_section d-flex align-items-center justify-content-between">
        <NavLink to={`/ScheduleQListHW`} className="link" state={{ homework_id: props.id }}>
          <span>
            Class {props.Scheduled_class_section} - {props.Scheduled_subject}
          </span>
        </NavLink>
        <Popup
          trigger={
            <img
              src="/images/menu-dots-vertical 1.svg"
              className="hw_card_three_dot"
              alt=""
            />
          }
          content={
            <div className="hw_popup_box_size">
              <ScheduleCardPopup props={props.id} />
            </div>
          }
          on="click"
          hideOnScroll
          position="bottom right"
        />
      </div>
      <NavLink to={`/ScheduleQListHW`} className="link" state={{ homework_id: props.id }}>
        <div className=" d-flex align-items-center justify-content-between">
          <span className="mt-1 hw_card_name" title={props.Scheduled_assessName}>
            {props.Scheduled_assessName}
          </span>
        </div>
        <div className="col-12 p-0  d-flex  justify-content-between ">
          <div className="col-6 p-0 ">
            <span className="hw_card_deadline">Deadline : </span>
            <span className="hw_card_date">{props.deadline_date}</span>
          </div>
          <div className="col-5 p-0 d-flex align-items-end flex-column ">
            <span className="hw_card_deadline">Scheduled on </span>
            <span className="hw_card_date">{props.schedule_date}</span>
          </div>
        </div>
        {/* <div className="d-flex align-items-center justify-content-between">
          <span>
            <span className="hw_card_deadline">Deadline : </span>
            <span className="hw_card_date"> {props.schedule_date}</span>
          </span>
        </div> */}
      </NavLink>
    </div>
  );
};

export default ScheduleAssessBoxHW;
